@if (url$ | async; as url) {
  <div class="nav-container">
    @if (url !== '/blog') {
      <a class="home-btn" routerLink="/blog" mat-button aria-label="Back button">
        <rma-icon glyph="chevron_left" />
        <span>Back</span>
      </a>
    }
    <mat-chip-listbox aria-label="Category Selection">
      @for (cat of blogCategories; track cat; let i = $index) {
        <mat-chip-option class="rma-chip" [selected]="url.includes(cat.slug)" routerLinkActive="active-route">
          @if (cat.id > 0) {
            <a class="text-" [routerLink]="['category', cat.slug]">{{ cat.name }}</a>
          }
          @if (cat.id < 0) {
            <a [routerLink]="cat.slug">{{ cat.name }}</a>
          }
        </mat-chip-option>
      }
    </mat-chip-listbox>
    <mat-form-field appearance="outline" class="mat-input-density-sm" subscriptSizing="dynamic">
      <mat-label>More categories</mat-label>
      <mat-select disableOptionCentering>
        @for (cat of blogCategories; track cat; let i = $index) {
          <mat-option class="rma-dropdown-option" [value]="cat.slug">
            @if (cat.id > 0) {
              <a [routerLink]="['category', cat.slug]">{{ cat.name }}</a>
            }
            @if (cat.id < 0) {
              <a [routerLink]="cat.slug">{{ cat.name }}</a>
            }
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}
